module.exports = __webpack_public_path__ + "img/logo.NFTy.today.beta.838a15dd.png";